import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { SEARCH, SearchContext } from "../SearchContext"
import SearchAdults from '../fields/SearchAdults'
import SearchKids from '../fields/SearchKids'

const _createArray = (length, startingIndex = 1) => Array.from({ length: length }, (_, i) => {
  return {id: i + startingIndex, adults: 1, kids: 0}
})

const RoomsDataPanel = ({
  open,
  toggleOpen
}) => {
  const { state, dispatch } = useContext(SearchContext)
  const _setRoomsData = (rooms) => dispatch({type: SEARCH.ROOMS_DATA, payload: rooms})
  const _setAdults = (payload) => dispatch({ type: SEARCH.ADULTS.SET, payload })
  const _setChildren = (payload) => dispatch({ type: SEARCH.CHILDREN.SET, payload })

  const _setInitial = () => state.roomsData.length > 0
    ? state.roomsData
    : _createArray(state.rooms)
  const [data, setData] = useState(_setInitial())

  useEffect(() => _updateRoomsDataArray(), [state.rooms])

  const _updateRoomsDataArray = () => {
    let roomNumberTotal = state.rooms
    if(state.roomsData.length !== roomNumberTotal ) {
      let roomsArray = [], tmpRooms = state.roomsData

      if (tmpRooms.length === 0) {
        roomsArray = _createArray(roomNumberTotal)
      } else if(state.roomsData.length > roomNumberTotal) {
        // remove
        roomsArray = tmpRooms.slice(0, roomNumberTotal)
      } else {
        // add to end roomNumberTotal - tmpRooms.length
        let arrayLength = _createArray(roomNumberTotal - tmpRooms.length, tmpRooms.length + 1)
        roomsArray = tmpRooms.concat(arrayLength)
      }
      _setRoomsData(roomsArray)
      setData(roomsArray)
    }
  }

  const _sumTotalOfObjKey = (key, rooms) => rooms.reduce((a, b) => a + (b[key] || 0), 0)

  const _setAdult = (value, i) => {
    let rooms = [...state.roomsData]
    rooms[i].adults = value
    _setRoomsData(rooms)
    setData(rooms)
    _setAdults(_sumTotalOfObjKey("adults", rooms))
  }

  const _setKid = (value, i) => {
    let rooms = [...state.roomsData]
    rooms[i].kids = value
    _setRoomsData(rooms)
    setData(rooms)
    _setChildren(_sumTotalOfObjKey("kids", rooms))
  }

  const _togglePanel = (e) => {
    e.preventDefault()
    toggleOpen(!open)
  }

  const _displayRoomData = () => {
    const rooms = Array.from({ length: state.roomsData.length }, (_, i) => {
      return (
        <div className="room-data" key={i}>
          <SearchAdults
            setAdults = {(value) => _setAdult(value, i)}
            controlledValue = {data[i].adults}
            />
          <SearchKids
            setKids = {(value) => _setKid(value, i)}
            controlledValue = {data[i].kids}
            />
          <h5>
            <i className="fas fa-bed main-icon" />
            Room #{i + 1}
          </h5>
        </div>
      )}
    )
    return rooms
  }

  return (
    <div
      className={`rooms-data-panel ${open ? "open" : ''}`}
      >
      <button
        role="button"
        className="plain text close"
        onClick={_togglePanel}
        >
        <i className="fas fa-chevron-up" />
      </button>
      <h3 className="show-on-mobile">Enter Individual Room Data</h3>
      { _displayRoomData() }
    </div>
  )
}

RoomsDataPanel.propTypes = {
  open: PropTypes.bool.isRequired,
  toggleOpen: PropTypes.func.isRequired
}

export default RoomsDataPanel
